<div class="general-user-list-container">
  <div class="header-container">
    <p class="header-text">Nutzerverwaltung</p>
    <div class="search-wrapper">
      <app-searchbar
        [placeholder]="'Schnellsuche'"
        [dataTestId]="userTestIds.userSearch"
        (searchTermChange)="onSearchChange($event)" />
    </div>
  </div>
  <nav mat-tab-nav-bar fitInkBarToContent class="general-users-tabs" [mat-stretch-tabs]="false" [tabPanel]="tabPanel">
    @for (tab of tabs; track tab.path) {
      <a
        mat-tab-link
        class="general-users-tab"
        [attr.data-testid]="oidcTestIds.userTab + tab.path"
        [routerLink]="tab.path"
        routerLinkActive
        #rla="routerLinkActive"
        [active]="rla.isActive">
        {{ tab.label }}
      </a>
    }
  </nav>

  <mat-tab-nav-panel #tabPanel class="general-users-content">
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</div>
